var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard" }, [
    _c(
      "div",
      { staticClass: "layout wrap widgets" },
      _vm._l(_vm.widgetList, function(item) {
        return _c(
          "v-flex",
          {
            key: item.key,
            class: item.title.replace(" ", "_"),
            attrs: { md1: "", "wrapper-widget": "", id: "cardDashboard" },
            on: {
              click: function($event) {
                return _vm.filtroWidget(item)
              }
            }
          },
          [
            _c("p", { staticClass: "titleCard" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    item.title
                      .replace("VEHICULOS", "VEHÍCULOS")
                      .replace("BOTON", "BOTÓN")
                  ) +
                  "\n      "
              )
            ]),
            _c("p", { staticClass: "count" }, [_vm._v(_vm._s(item.value))])
          ]
        )
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }